import React from 'react';
import { ContentContainer, MainContainer } from '@atoms/tableData/styles/contentContainer.styles';
import PastSubHeaderMsl from '@molecules/msl/components/pastSubHeaderMsl';
import MslPastTable from '@templates/msl/forecast/tableComponent/past-forecast/mslPastTable';
import AlertBanner from '@atoms/alerts/alertBanner';

const MslPastForecast = props => {
  const account = props.data.account;
  const forecast_type = props.data.forecast_type;
  const year = props.data.year;
  const quarter = props.data.quarter;
  const email = props.data.email;
  let month = props.data.month;
  month = month.charAt(0).toUpperCase() + month.slice(1);

  return (
    <MainContainer>
      <ContentContainer>
        <AlertBanner
          title="NOTE"
          description="This is a view-only snapshot of the forecast you submitted."
          type="past"
        />
        <PastSubHeaderMsl
          year={year}
          forecast_type={forecast_type}
          month={month}
          quarter={quarter}
          email={email}
          account={account}
        />
        <MslPastTable
          email={email}
          year={year}
          month={month}
          quarter={quarter}
          forecast_type={forecast_type}
          account={account}
        />
      </ContentContainer>
    </MainContainer>
  );
};

export default MslPastForecast;
